import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateOperativeUnitHasOnCallTypeDto {
  @Expose()
  id: string;

  @Expose()
  @Transform(({ value }) => (value === null || value === undefined ? undefined : toCents(value)))
  cost?: number;

  @Expose()
  @Transform(({ value }) => (value === null || value === undefined ? undefined : toCents(value)))
  price?: number;
}
